import { APPLE_PAY_METHOD, GOOGLE_PAY_METHOD } from '../constants/PaymentElement';
export const getWalletType = paymentMethod => {
  return paymentMethod === GOOGLE_PAY_METHOD || paymentMethod === APPLE_PAY_METHOD ? paymentMethod : null;
};